import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchRates = createAsyncThunk(
  'rates/fetchRates',
  async ({ filters = {} } = {}) => {
    const response = await axiosClient.get('/companies/selected/rates', {
      params: {
        ...filters
      }
    })
    return response.data
  }
)

const fetchRate = createAsyncThunk(
  'rates/fetchRate',
  async ({ id }) => {
    const response = await axiosClient.get(`/companies/selected/rates/${id}`)
    return response.data
  }
)

const updateRate = createAsyncThunk(
  'rates/updateRate',
  async ({ id, data }) => {
    const response = await axiosClient.put(`/companies/selected/rates/${id}`, data);
    return response.data;
  }
);

const deleteRate = createAsyncThunk(
  'rates/deleteRate',
  async ({ id }) => {
    const response = await axiosClient.delete(`/companies/selected/rates/${id}`)
    return response.data
  }
)

const fetchSubscriptionTypes = createAsyncThunk(
  'rates/fetchSubscriptionTypes',
  async () => {
    const response = await axiosClient.get('/companies/selected/rates/subscription-types')
    return response.data
  }
)

const fetchCurrencies = createAsyncThunk(
  'rates/fetchCurrencies',
  async () => {
    const response = await axiosClient.get('/companies/selected/rates/currencies')
    return response.data
  }
)

const fetchFreePeriodUnits = createAsyncThunk(
  'rates/fetchFreePeriodUnits',
  async () => {
    const response = await axiosClient.get('/companies/selected/rates/free-period-units')
    return response.data
  }
)

const initialState = {
  listItems: {
    items: [],
    page: 1,
    page_size: 10,
    count: 0
  },
  rates: [],
  rate: null,
  subscriptionTypes: [],
  paymentPeriods: [],
  currencies: [],
  freePeriodUnits: []
}

export const slice = createSlice({
  name: 'rates',
  initialState,
  reducers: {
    setListItems(state, { payload }) {
      state.listItems = {
        ...state.listItems,
        ...payload
      }
    },
    resetListItems(state) {
      state.listItems = { items: [], page: 1, page_size: 10, count: 0 }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRates.fulfilled, (state, { payload }) => {
      if (!payload) {
        state.listItems.items = []
        state.listItems.count = 0
        return
      }

      const { count = 0, results = null } = payload
      const items = Array.isArray(results) ? results : (Array.isArray(payload) ? payload : (payload.results || []))
      state.listItems = {
        ...state.listItems,
        items,
        count
      }
      state.rates = items
    })

    builder.addCase(fetchRate.fulfilled, (state, { payload }) => {
      state.rate = payload
    })

    builder.addCase(updateRate.fulfilled, (state, { payload }) => {
      state.rate = payload
    })

    builder.addCase(deleteRate.fulfilled, (state /*, { payload } */) => {
      state.rate = null
    })

    builder.addCase(fetchSubscriptionTypes.fulfilled, (state, { payload }) => {
      state.subscriptionTypes = payload
    })

    builder.addCase(fetchCurrencies.fulfilled, (state, { payload }) => {
      state.currencies = payload
    })

    builder.addCase(fetchFreePeriodUnits.fulfilled, (state, { payload }) => {
      state.freePeriodUnits = payload || []
    })
  }
})

export const { setListItems, resetListItems } = slice.actions

export {
  fetchRates,
  fetchRate,
  updateRate,
  deleteRate,
  fetchSubscriptionTypes,
  fetchCurrencies,
  fetchFreePeriodUnits
}

export default slice.reducer
